import React from "react";
import { t } from "../../../../utils/i18n";

const ProductDetailsForm = ({
  formData,
  handleInputChange,
  handleBlur,
  errors,
}) => {
  return (
    <>
      {/* Product Name Input */}
      <div className="form-group">
        <label htmlFor="product_name">{t("store_integrations.widget.product_name_req")}</label>
        <input
          type="text"
          id="product_name"
          name="product_name"
          value={formData.product_name}
          onChange={handleInputChange}
          onBlur={handleBlur}
          placeholder={t("store_integrations.widget.product_name_placeholder")}
          className={`form-input ${errors.product_name ? "error" : ""}`}
          required
          maxLength={100}
          aria-describedby={
            errors.product_name ? "product-name-error" : undefined
          }
        />
        {errors.product_name && (
          <div className="error-message" id="product-name-error">
            {errors.product_name}
          </div>
        )}
      </div>

      {/* Description Input */}
      <div className="form-group">
        <label htmlFor="description">{t("store_integrations.widget.description_req")}</label>
        <input
          type="text"
          id="description"
          name="description"
          value={formData.description}
          onChange={handleInputChange}
          onBlur={handleBlur}
          placeholder={t("store_integrations.widget.description_placeholder")}
          className={`form-input ${errors.description ? "error" : ""}`}
          required
          maxLength={255}
          aria-describedby={
            errors.description ? "description-error" : undefined
          }
        />
        {errors.description && (
          <div className="error-message" id="description-error">
            {errors.description}
          </div>
        )}
      </div>

      {/* Pay Button CTA Input */}
      <div className="form-group">
        <label htmlFor="pay_button_cta">{t("store_integrations.widget.cta_label")}</label>
        <input
          type="text"
          id="pay_button_cta"
          name="pay_button_cta"
          value={formData.pay_button_cta}
          onChange={handleInputChange}
          placeholder={t("store_integrations.widget.cta_placeholder")}
          className="form-input"
          maxLength={50}
        />
        <small>{t("store_integrations.widget.cta_help")}</small>
      </div>

      {/* Pay Button Note Input */}
      <div className="form-group">
        <label htmlFor="pay_button_note">{t("store_integrations.widget.note_label")}</label>
        <input
          type="text"
          id="pay_button_note"
          name="pay_button_note"
          value={formData.pay_button_note}
          onChange={handleInputChange}
          placeholder={t("store_integrations.widget.note_placeholder")}
          className="form-input"
          maxLength={100}
        />
        <small>{t("store_integrations.widget.note_help")}</small>
      </div>

      {/* Redirect URL Input */}
      <div className="form-group">
        <label htmlFor="redirect_url">{t("store_integrations.widget.redirect_label")}</label>
        <input
          type="url"
          id="redirect_url"
          name="redirect_url"
          value={formData.redirect_url}
          onChange={handleInputChange}
          placeholder="https://yourdomain.com/thank-you"
          className="form-input"
        />
      </div>
    </>
  );
};

export default ProductDetailsForm;
